import { Inject, Injectable } from '@angular/core';
import { BuildConfigService, WINDOW } from '@common/util-foundation';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { first, tap } from 'rxjs/operators';
import * as ResetStateActions from './reset-state.actions';

@Injectable()
export class RestartJourneyEffects {
  restart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          ResetStateActions.restartCheckoutGuest,
          ResetStateActions.restartCheckoutLoggedInUser,
          ResetStateActions.restartCheckoutBackButton
        ),
        tap(() => {
          this.window.location.replace(
            this.buildConfigService.config.applianceDetailsPage
          );
        })
      ),
    { dispatch: false }
  );

  sessionInactivityTimeout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ResetStateActions.sessionInactivityTimeout),
        first(),
        tap(() => {
          this.window.location.replace(
            this.buildConfigService.config.applianceDetailsPage
          );
        })
      ),
    { dispatch: false }
  );

  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly actions$: Actions,
    private readonly buildConfigService: BuildConfigService
  ) {}
}
